import React, { useContext, useEffect } from "react";
import HelperTextEnum from "../../shared/enums/helper-text.enum";
import { StrengthIndicatorContext } from "../../shared/contexts/StrengthIndicatorContext";
import { Box } from "@mui/material";
import { useStyles } from "./StrengthIndicator.styles";
import { PASSWORD_STRENGTH_PATTERN } from "../../shared/constants/password-validation";

interface StrengthIndicatorProps {
    password: string;
    clearErrors: (name?: string | string[]) => void;
}

const StrengthIndicator = ({ password }: StrengthIndicatorProps) => {
    const { strengthIndicator, setStrengthIndicator } = useContext(StrengthIndicatorContext);
    const styles = useStyles();

    useEffect(() => {
        strengthIndicatorTest();
    }, [password]);

    const strengthIndicatorTest = () => {
        const rgx_pwd = PASSWORD_STRENGTH_PATTERN.test(password);

        if (password.length === 0) {
            setStrengthIndicator(HelperTextEnum.PASSWORD_STRENGTH);
        } else if (password.length >= 10 && password.length <= 11 && rgx_pwd) {
            setStrengthIndicator(HelperTextEnum.MEDIUM_PASSWORD);
        } else if (password.length >= 12 && rgx_pwd) {
            setStrengthIndicator(HelperTextEnum.STRONG_PASSWORD);
        } else {
            setStrengthIndicator(HelperTextEnum.WEAK_PASSWORD);
        }
    };

    function switchIndicator(strengthIndicator: string | null) {
        switch (strengthIndicator) {
            case "Slabé heslo":
                return (
                    <Box className={styles.indicatorWrapper}>
                        <div className={styles.passDots}>
                            <div className={styles.dot1Red}></div>
                            <div className={styles.dot2Grey}></div>
                            <div className={styles.dot3Grey}></div>
                        </div>
                        <div className={styles.passText}>
                            <span className={styles.indicatorStyle}>{strengthIndicator}</span>
                        </div>
                    </Box>
                );
            case "Středně silné heslo":
                return (
                    <Box className={styles.indicatorWrapper}>
                        <div className={styles.passDots}>
                            <div className={styles.dot1Orange}></div>
                            <div className={styles.dot2Orange}></div>
                            <div className={styles.dot3Grey}></div>
                        </div>
                        <div className={styles.passText}>
                            <span className={styles.indicatorStyle}>{strengthIndicator}</span>
                        </div>
                    </Box>
                );
            case "Silné heslo":
                return (
                    <Box className={styles.indicatorWrapper}>
                        <div className={styles.passDots}>
                            <div className={styles.dot1Green}></div>
                            <div className={styles.dot2Green}></div>
                            <div className={styles.dot3Green}></div>
                        </div>
                        <div className={styles.passText}>
                            <span className={styles.indicatorStyle}>{strengthIndicator}</span>
                        </div>
                    </Box>
                );
        }
    }

    return <div>{switchIndicator(strengthIndicator)}</div>;
};

export default StrengthIndicator;
